import { useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import Navbar from '../../components/ALLJsx/Navbar';
import Footer from '../../components/ALLJsx/Footer';
import { FAQ_ITEMS, isValidQuestion } from '../../data/faqSupportContent';
import { getFaqAnswer } from '../../utils/faqSupportText';
import FaqAnswerBody from '../../components/ALLJsx/FaqAnswerBody';
import { FaqBreadcrumb, FaqExpertSection } from './FaqSupportShared';
import '../AllCss/FaqSupport.css';

function FaqSupportArticle() {
  const { categoryId, questionId } = useParams();
  const { t } = useLocale();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [categoryId, questionId]);

  if (!isValidQuestion(categoryId, questionId)) {
    return <Navigate to="/faq-support" replace />;
  }

  const categoryLabel = t(`faqSupport.categories.${categoryId}`);
  const questionLabel = t(`faqSupport.questions.${categoryId}.${questionId}.q`);
  const answer = getFaqAnswer(categoryId, questionId, t);
  const relatedQuestions = FAQ_ITEMS[categoryId].filter((id) => id !== questionId);

  return (
    <div className="faq-page">
      <Navbar />

      <section className="faq-sub-hero">
        <div className="faq-shell faq-sub-hero-inner">
          <FaqBreadcrumb
            items={[
              { label: t('faqSupport.helpCenter'), to: '/faq-support' },
              { label: categoryLabel, to: `/faq-support/${categoryId}` },
            ]}
          />
          <h1 className="faq-sub-title">{questionLabel}</h1>
        </div>
      </section>

      <section className="faq-article">
        <div className="faq-shell faq-article-layout">
          <div className="faq-article-main">
            <FaqAnswerBody text={answer} />
          </div>

          {relatedQuestions.length > 0 && (
            <aside className="faq-article-aside" aria-labelledby="faq-related-title">
              <h2 id="faq-related-title" className="faq-article-aside-title">
                {t('faqSupport.moreInTopic', { topic: categoryLabel })}
              </h2>
              <ul className="faq-article-related">
                {relatedQuestions.map((relatedId) => (
                  <li key={relatedId}>
                    <Link to={`/faq-support/${categoryId}/${relatedId}`}>
                      {t(`faqSupport.questions.${categoryId}.${relatedId}.q`)}
                      <ArrowRight size={16} strokeWidth={2.25} aria-hidden />
                    </Link>
                  </li>
                ))}
              </ul>
            </aside>
          )}
        </div>
      </section>

      <FaqExpertSection />
      <Footer />
    </div>
  );
}

export default FaqSupportArticle;
